module.exports = __webpack_public_path__ + "static/media/etable.a973e920.jpg";